import { useEffect } from "react";

export const BookmarkVisitTracker = () => {
  useEffect(() => {
    try {
      const q = new URLSearchParams(window.location.search);
      const ref = document.referrer || "";
      const fromUtm = q.get("utm_medium") === "bookmark";
      const external = ref && !ref.includes(window.location.hostname);
      if (!fromUtm && !external) return;
      const key = `gf_bm_${q.get("utm_source") || "ref"}_${q.get("utm_campaign") || ""}_${new Date().toISOString().slice(0, 10)}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/bm/visit`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ site: q.get("utm_source") || "", pack: (q.get("utm_campaign") || "").replace(/^bm_/, ""), path: window.location.pathname, referrer: ref }), keepalive: true }).catch(() => {});
    } catch { /* ignore */ }
  }, []);
  return null;
};
